/**
 * RoofList - Container for the roof selection list
 *
 * Displays all established roofs with their status and allows selection/removal.
 */

import React from 'react';
import { RoofListItem } from './RoofListItem';

interface RoofData {
  id: number;
  area: number;
  moduleCount: number;
}

interface RoofListProps {
  roofs: RoofData[];
  activeRoofId: number | null;
  selectedPolygon: number | null;
  onSelectRoof: (roofId: number) => void;
  onRemoveRoof: (roofId: number) => void;
}

export function RoofList({
  roofs,
  activeRoofId,
  selectedPolygon,
  onSelectRoof,
  onRemoveRoof,
}: RoofListProps) {
  if (roofs.length === 0) return null;

  return (
    <div className="pt-4 border-t-2 border-gray-200">
      <label className="text-xs text-gray-600 mb-2 block font-semibold">
        ROOF LIST ({roofs.length})
      </label>
      <div className="space-y-2 max-h-[300px] overflow-y-auto">
        {roofs.map(roof => {
          const isActive = activeRoofId === roof.id || (roofs.length === 1 && selectedPolygon === roof.id);

          return (
            <RoofListItem
              key={roof.id}
              roofId={roof.id}
              isActive={isActive}
              area={roof.area}
              moduleCount={roof.moduleCount}
              onSelect={() => onSelectRoof(roof.id)}
              onRemove={() => onRemoveRoof(roof.id)}
            />
          );
        })}
      </div>
      <p className="text-xs text-gray-500 mt-2">
        Click a roof to make it active for module placement
      </p>
    </div>
  );
}

export default RoofList;
